module.exports = __webpack_public_path__ + "static/media/a4.3ceb7ef6.jpg";